import { useState } from "react"

const useShowPass = () => {
  const [showPassOne, setShowPassOne] = useState(false)
  const [showPassTwo, setShowPassTwo] = useState(false)
  const [showPassThree, setShowPassThree] = useState(false)

  const showPassInputOneHandler = () => {
    setShowPassOne(!showPassOne)
  }

  const showPassInputTwoHandler = () => {
    setShowPassTwo(!showPassTwo)
  }

  const showPassInputThreeHandler = () => {
    setShowPassThree(!showPassThree)
  }

  return {
    showPassInputOneHandler,
    showPassInputTwoHandler,
    showPassInputThreeHandler,
    showPassOne,
    showPassTwo,
    showPassThree,
  }
}

export default useShowPass
